
import { ProxyServerType } from '../biz/proxyType';
import { httpApi } from './basicHttpApi';

export const fetchPoolProxies = async (poolId: number) => {
  const result = await httpApi(`pools/proxies/${poolId}`, undefined, "GET");
  return result.proxies as ProxyServerType[];
};
